import {
    REFERRAL_OFFER_IDS,
    getPersonalReferralIdFromCookie,
} from '@ratehub/base-ui';


/**
 * Is this credit card eligible for a referral offer, based on the arguments provided associated with the card and
 * other relevant factors, including a referral cookie being present?
 * @param {boolean} [hasReferralOffer = false] - has this card been made eligible for a referral bonus?
 * @returns {boolean} - true if the card is eligible for a referral offer
 */
function isCardEligibleForReferralOffer(hasReferralOffer = false) {
    return hasReferralOffer && getPersonalReferralIdFromCookie(REFERRAL_OFFER_IDS.creditCard) !== null;
}


export default isCardEligibleForReferralOffer;
